import { BannerItemAttributes } from "~/models/bannerprops";
import { BannerView } from "./BannerView";

export const BannerEdit = ({ list }: { list: BannerItemAttributes[] }) => {
  return <BannerView list={list} />;
};
